namespace $ {
	/** Stable content revision, including replacements, deletions and concurrent peers. */
	export function $shm_hitalama_file_cache_version( file: $giper_baza_file ) {
		return JSON.stringify([
			file.link().str,
			file.type(),
			(file.Chunks()?.units() ?? []).map(unit=>[unit.lord().str,unit.self().str,unit.time_tick()]),
		])
	}

	/** Bytes and their revision are published together under a cross-tab lock. */
	export class $shm_hitalama_file_cache extends $mol_object {
		static metadata_name( name: string ) { return name + '.shm-cache-version' }
		static lock_name( name: string ) { return '$shm_hitalama_file_cache:' + name }

		static async read( name: string, version?: string ) {
			return navigator.locks.request(this.lock_name(name), {mode:'shared'}, async()=>{
				const root=await navigator.storage.getDirectory()
				if(version !== undefined) {
					const metadata=await root.getFileHandle(this.metadata_name(name))
					if(await (await metadata.getFile()).text() !== version) {
						throw new DOMException('Cached file revision has changed','NotFoundError')
					}
				}
				return (await root.getFileHandle(name)).getFile()
			})
		}

		static async write( file: Blob, name: string, version?: string ) {
			return navigator.locks.request(this.lock_name(name), async()=>{
				const root=await navigator.storage.getDirectory()
				const metadata=this.metadata_name(name)
				try { await root.removeEntry(metadata) }
				catch(error) { if((error as DOMException).name !== 'NotFoundError') throw error }
				const handle=await root.getFileHandle(name,{create:true})
				await this.write_handle(handle,file)
				if(version !== undefined) {
					const marker=await root.getFileHandle(metadata,{create:true})
					await this.write_handle(marker,new Blob([version]))
				}
				return handle
			})
		}

		static async write_handle( handle: FileSystemFileHandle, blob: Blob ) {
			const writable=await handle.createWritable()
			try { await writable.write(blob); await writable.close() }
			catch(error) { await writable.abort().catch(()=>{}); throw error }
		}

		static async remove( name: string ) {
			return navigator.locks.request(this.lock_name(name),async()=>{
				const root=await navigator.storage.getDirectory()
				for(const entry of [this.metadata_name(name),name]) {
					try { await root.removeEntry(entry) }
					catch(error) { if((error as DOMException).name !== 'NotFoundError') throw error }
				}
			})
		}
	}
}
